module.exports = __webpack_public_path__ + "static/media/eveningStandard.7a99c27f.svg";